import { render, staticRenderFns } from "./user.vue?vue&type=template&id=ff877a42&scoped=true"
import script from "./user.vue?vue&type=script&lang=js"
export * from "./user.vue?vue&type=script&lang=js"
import style0 from "./user.vue?vue&type=style&index=0&id=ff877a42&prod&scoped=true&lang=scss"
import style1 from "./user.vue?vue&type=style&index=1&id=ff877a42&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff877a42",
  null
  
)

export default component.exports